import type { PersonModel } from 'src/tpbp-json-api-handler/models/models'
import { CREATION_TYPES } from '../relation/relation.const'
import { getFormattedDates } from './person.validation.utils'

export function validatePersonMinDateOfBirthControl(): string {
  return getFormattedDates().TODAY_MINUS_150_YEARS
}

export function validatePersonMaxDateOfBirthControl(
  personRecord: PersonModel,
): string {
  return personRecord.creationType === CREATION_TYPES.partner
    ? getFormattedDates().TODAY_MINUS_15_YEARS
    : getFormattedDates().TODAY
}
